
const createPmkinoWebAppState = () => {
    
    let cinemaId = pmkinoFrontVars?.cliData?.currentCinemaId
    let websiteUrl = pmkinoFrontVars?.cinemaData?.site.url_site

    return {
        "cinemaId": cinemaId,
        "websiteUrl": websiteUrl
    }
}



export default createPmkinoWebAppState